import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../../Context/UserContext";
import css from "./Sidebar.module.css";

export const ResearchBar = () => {
  const { userData, userResearch } = React.useContext(UserContext);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  if (userData) {
    return (
      <div className={css.sidebar}>
        <div className={css.sidebarWrapper}>
          <div className={css.sidebarMenu}>
            <button
              className={css.userButton}
              onClick={() => navigate("/researcher")}
            />
            <h3 className={css.sidebarTitle}>{userData?.displayName}</h3>
            <ul className={css.sidebarList}>
              <Link to="/researcher/new-user" className={css.link}>
                <li className={`${css.sidebarListItem}`}>
                  <i className={`material-icons ${css.sidebarIcon}`}>person</i>
                  Novo Participante
                </li>
              </Link>

              <Link to="/researcher/participants" className={css.link}>
                <li className={`${css.sidebarListItem}`}>
                  <i className={`material-icons ${css.sidebarIcon}`}>group</i>
                  Participantes
                </li>
              </Link>

              <Link to="/researcher/results" className={css.link}>
                <li className={`${css.sidebarListItem}`}>
                  <i className={`material-icons ${css.sidebarIcon}`}>
                    leaderboard
                  </i>
                  Resultados
                </li>
              </Link>
            </ul>
          </div>

          <div
            className={`copyright ${
              userData?.staff ? css.sidebarMenu : css.copyright
            } `}
          >
            ibhava.com © 2025
          </div>
        </div>
      </div>
    );
  } else {
    return <div className={css.sidebar}></div>;
  }
};
